import CreateSemester from '../components/CreateSemester';
import PageLayout from '../components/pageLayout';

function CreateSemesterPage() {
    return (
        <PageLayout children={<CreateSemester />} />
    );
}

export default CreateSemesterPage;
